import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliveryTransportsView } from "src/components/views/erp/delivery/deliveryTransport/DeliveryTransportsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/delivery/transports")({
	staticData: { title: i18n.t("transports"), legacyViewKey: "deliveryTransportsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliveryTransportsView />;
}
